<div class="nlf-modal__header">
	<h2 class="nlf-modal__header__title" id="modal__title">{{ 'modals.navigateAway.title.leaveBooking' | ibeadmin: 'sync' }}</h2>
	<div class="nlf-modal__header__actions">
		<button *ngIf="!isLoading" attr.aria-label="{{ 'modals.navigateAway.aria.closeDialog' | ibeadmin: 'sync' }}" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>
<ng-container *ngIf="!isLoading">
	<div class="nlf-modal__body sl--scrollable">
		{{ 'modals.navigateAway.text.youWillLoseProgress' | ibeadmin: 'sync' }}
	</div>
	<hr class="nlf-modal__divider">
	<div class="nlf-modal__footer">
		<div class="nlf-modal__footer__actions">
			<button class="button button--small button-main-line" (click)="TAP_handleConfirm()">{{ 'modals.navigateAway.text.leaveThisPage' | ibeadmin: 'sync' }}</button>
			<button class="button button--small" (click)="TAP_handleCancel()">{{ 'modals.navigateAway.text.continueBooking' | ibeadmin: 'sync' }}</button>
		</div>
	</div>
</ng-container>

<app-loading *ngIf="isLoading"></app-loading>
